export const CURRENCY_NAME = 'love'
